import React from 'react';
import PropTypes from 'prop-types';

const IconGift = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        <path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8" />
        <path d="M21.5 7.5h-19A.5.5 0 0 0 2 8v3.5a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5Z" />
        <path d="M12 7.5V21" />
        <path d="M12 7.5H7.75a2.25 2.25 0 1 1 0-4.5C10.5 3 12 7.5 12 7.5Z" />
        <path d="M12 7.5h4.25a2.25 2.25 0 1 0 0-4.5C13.5 3 12 7.5 12 7.5Z" />
      </g>
    </svg>
  );
};

IconGift.defaultProps = { className: null };

const { string } = PropTypes;

IconGift.propTypes = {
  className: string,
};

export default IconGift;
